/**
 * Clicks inside these elements must not close other modals/popups
 * (e.g. ticket popup vs AI agent panel).
 */
export const CLICK_OUTSIDE_EXCLUDED_SELECTORS = [
    '[data-cy="ai-agent"]',
    '[data-cy="account-ai-agent-fab"]',
    '.ai-agent-panel',
    '.ai-message-generator-panel',
] as const;

export const isClickOutsideExcludedTarget = (target: EventTarget | null): boolean => {
    if(!(target instanceof Element)) {
        return false;
    }
    return CLICK_OUTSIDE_EXCLUDED_SELECTORS.some(selector => !!target.closest(selector));
};
